export enum LabRegistrationActionTypes {
    API_RESPONSE_SUCCESS = '@@labRegistration/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@labRegistration/API_RESPONSE_ERROR',

    ADD_LAB_REGISTRATION = '@@labRegistration/ADD_LAB_REGISTRATION',
    EDIT_LAB_REGISTRATION = '@@labRegistration/EDIT_LAB_REGISTRATION',
    GET_LAB_REGISTRATION = '@@labRegistration/GET_LAB_REGISTRATION',
    GET_LAB_REGISTRATIONS = '@@labRegistration/GET_LAB_REGISTRATIONS',
    RESET = '@@labRegistration/RESET',
    RESET_SUCCESS = '@@labRegistration/RESET_SUCCESS',
    RESET_ERROR = '@@labRegistration/RESET_ERROR',
}
